<template>
    <div v-if="ShopItem.out_of_production == 0">
        <!-- Prices -->
        <div class="uk-flex uk-flex-between uk-text-xsmall uk-text-muted">

            <div>Кол-во</div>

            <div>Цена</div>

        </div>

        <div class="tm-prices uk-text-small uk-margin-xsmall-top">
            <ul class="uk-list">

                <product-price-row v-for="ProductPrice in ProductPrices"
                                   :key="ProductPrice.ShopItemPrice.id"
                                   :price="ProductPrice.ShopItemPrice"
                                   :currency="ProductPrice.ShopCurrency"
                                   :type="ProductPrice.ShopItemPriceType"
                                   :is-selected="ProductPrice.ShopItemPrice.id === selectedProductPrice.ShopItemPrice.id">
                </product-price-row>

            </ul>
        </div>

        <!-- Add to cart -->

        <div v-if="hasQuantity === true" class="uk-margin-small-top">
            <div class="tm-label-block">
                <span v-for="ShopItemWarehouse in ShopItemWarehouses" class="uk-label uk-label-success">В наличии {{ ShopItemWarehouse.quantity }} шт.</span>
            </div>
        </div>

        <div class="uk-grid-small uk-margin-small-top" uk-grid>


            <div v-show="!inCart" class="uk-flex uk-flex-inline uk-position-z-index">
                <input v-model.number="quantity" class="uk-input uk-text-center tm-quantity-input">
                <div class="tm-quantity-buttons">
                    <button @click="plus" class="tm-inc-button uk-flex uk-flex-center uk-flex-middle"><span
                            uk-icon="plus"></span></button>
                    <button @click="minus" class="tm-dec-button uk-flex uk-flex-center uk-flex-middle"><span
                            uk-icon="minus"></span></button>
                </div>
            </div>

            <div v-show="!inCart" class="uk-width-expand uk-position-z-index">
                <button :disabled="!canBuy"
                        @click="$emit('buy-shop-item',quantity,ShopItem)"
                        class="uk-button uk-button-primary uk-width-1-1">
                    <span uk-icon="icon: cart"></span> Купить
                </button>
            </div>

            <div v-show="inCart" class="uk-width-expand uk-position-z-index">
                <a href="/cart" class="uk-button uk-button-primary uk-width-1-1">
                    <span>В корзине</span>
                </a>
            </div>

        </div>

    </div>
    <div v-else class="uk-text-center">
        <div class="uk-text-danger uk-text-bold">Товар снят с производства</div>
        <div class="uk-text-primary">Звоните, мы поможем подобрать аналог!</div>
        <div class="uk-flex uk-flex-middle uk-flex-center tm-contact-phone">
            <span uk-icon="icon: phone; ratio: 1.4" class="uk-text-muted uk-icon"></span><a href="tel:+78126221770"
                                                                                            class="uk-text-lead uk-link-text">+7 (812) 622-17-70</a>
        </div>
        <div v-if="RelatedShopItems.length" class="uk-child-width-1-1"
             style="border-top: 1px dashed #000;padding-top: 13px;margin-top: 13px;">
            <div class="uk-text-bold">Похожие товары:</div>
            <div class="uk-flex uk-flex-center uk-flex-wrap">
                <div v-for="(RelatedShopItem, index) in RelatedShopItems">
                    <a :key="RelatedShopItem.ShopItem.id" :href="RelatedShopItem.ShopItem.href" target="_blank">{{
                        RelatedShopItem.ShopItem.name }}</a><span v-if="index != RelatedShopItems.length-1">, </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductPriceRow from './ProductPriceRow'

    export default {
        name: "ShopItemPrices",
        components: {
            ProductPriceRow
        },
        props: {
            ShopItem: {
                type: Object,
                required: true
            },
            ShopOrderItem: {
                type: Object,
            },
            ProductPrices: {
                type: Array
            },
            ShopItemWarehouses: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            RelatedShopItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            }
        },
        data() {
            let qty = this.ProductPrices[0].ShopItemPrice.price_break;
            return {
                quantity: qty ? qty : 1,
                selectedProductPrice: {},
                loading: true
            }
        },
        created() {

        },
        watch: {
            quantity: {
                immediate: true,
                handler(newVal, oldVal) {
                    this.ProductPrices.map((ProductPrice) => {
                        if (this.quantity >= ProductPrice.ShopItemPrice.price_break) {
                            this.selectedProductPrice = ProductPrice;
                        }
                    });
                }
            }
        },
        computed: {
            canBuy() {
                return Number.isInteger(this.quantity) && this.quantity > 0;
            },
            inCart() {
                return !!this.ShopOrderItem.shop_item_id;
            },
            hasQuantity() {
                return this.ShopItemWarehouses.some((warehouse) => {
                    return warehouse.quantity > 0
                })
            },
        },
        methods: {
            plus() {
                this.quantity = parseInt(this.quantity) + 1;
            },
            minus() {
                if (parseInt(this.quantity) > 1) {
                    this.quantity = parseInt(this.quantity) - 1;
                }
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ProductPrices.vue?5aae1c14